(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('ConsoleHistoryService', ConsoleHistoryService);

    function ConsoleHistoryService() {

        var index = 0;
        var commands = [];

        var service = {
            add: add,
            prev: prev,
            next: next
        };

        return service;

        function add(command) {
            commands.push(command);
            index = commands.length;
        }

        function prev() {
            if (index > 0) {
                return commands[--index];
            }
            return commands[index];
        }

        function next() {
            if (index < commands.length) {
                return commands[++index];
            }
            return '';
        }

    }
})();